// 统一管理所有接口
import iotHome from './iotHome'

export default {
  iotHome
}